import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api.ts';
import { fmtNumber } from '../lib/format.ts';

export function AdminPage() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['etl-status'],
    queryFn: api.etlStatus,
    refetchInterval: 30_000,
  });

  if (error) return <div className="card card-body text-red-600">{(error as Error).message}</div>;
  if (isLoading || !data) return <div>Lade …</div>;

  return (
    <div className="space-y-4">
      <div className="card">
        <div className="card-header">ETL-Status</div>
        <div className="card-body space-y-2 text-sm">
          <Row label="Letzter Lauf" value={data.last_run ?? 'nie'} />
          <Row label="Dauer" value={data.duration_ms ? `${(data.duration_ms / 1000).toFixed(1)}s` : '—'} />
          <Row label="Zeilen Bons" value={fmtNumber(data.rows_bons)} />
          <Row label="Zeilen Positionen" value={fmtNumber(data.rows_positionen)} />
          <Row label="Zeilen Kassierer-Tage" value={fmtNumber(data.rows_kassierer)} />
          <Row label="Zeilen Payment-Tage" value={fmtNumber(data.rows_payments)} />
          {data.errors.length > 0 && (
            <div className="mt-2 p-2 bg-red-50 dark:bg-red-900 text-red-700 dark:text-red-200 rounded">
              {data.errors.map((e, i) => (
                <div key={i}>{e}</div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function Row({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex justify-between border-b border-slate-100 dark:border-slate-700 py-1">
      <span className="text-slate-500">{label}</span>
      <span className="font-mono">{value}</span>
    </div>
  );
}
